import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "./common/UserContext";
import config from "../envconfig";
import Cookies from "js-cookie";

const Dashboard = () => {
  const navigate = useNavigate();
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_UserType,
    UM_DisplayName
  } = useContext(UserContext);
  const [showWorkInProgressModal, setShowWorkInProgressModal] = useState(false);
  const [menuWithOptions, setMenuWithOptions] = useState([]);
  const [error, setError] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);

  const [scpOptions, setScpOptions] = useState([]);

  const [selectedMenu, setSelectedMenu] = useState(null); // New state for selected menu
  const [isDashboardSelected, setDashboardSelected] = useState(false);
  const [isWidgetSelected, setWidgetSelected] = useState(false);
  const [isAboutUsSelected, setAboutUsSelected] = useState(false);

  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const [selectedScpId, setSelectedScpId] = useState(() => {
    const storedScpData = JSON.parse(sessionStorage.getItem("selectedScpData"));
    return storedScpData?.id || UM_DefaultSCPId;
  });
  const [selectedScpName, setSelectedScpName] = useState(() => {
    const storedScpData = JSON.parse(sessionStorage.getItem("selectedScpData"));
    return storedScpData?.name || "";
  });

  // Utility function to fetch SCP name by ID
  const getScpNameById = (id, scpOptions) => {
    const scp = scpOptions.find((option) => option.id === id);
    return scp ? scp.name : "";
  };



 

  useEffect(() => {
    const scpName = getScpNameById(selectedScpId, scpOptions);

    // Check if a name is found or fallback to UM_DefaultSCPId
    if (scpName) {
      setSelectedScpName(scpName);

    } else {
      const defaultScpName = getScpNameById(UM_DefaultSCPId, scpOptions);
      setSelectedScpName(defaultScpName);

    }
  }, [selectedScpId, UM_DefaultSCPId, scpOptions]);


  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
    sessionStorage.setItem("UM_UserType", UM_UserType);
    sessionStorage.setItem("UM_DisplayName", UM_DisplayName);
    const selectedScpData = {
      id: selectedScpId,
      name: selectedScpName,
    };
    sessionStorage.setItem("selectedScpData", JSON.stringify(selectedScpData));

    // sessionStorage.setItem('selectedScpId', JSON.stringify(selectedScpData));
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
    selectedScpName,
    UM_UserType,
    UM_DisplayName
  ]);

  const handleWidgets = () => {
    setWidgetSelected(true);
    setDashboardSelected(false); // Set dashboard as selected
    setAboutUsSelected(false);
    setSelectedMenu(); // Update selected menu index

    navigate("/dashboard/Widgets");
  };
  const handleAboutUs = () => {
    setAboutUsSelected(true);
    setWidgetSelected(false)
    setDashboardSelected(false); // Set dashboard as selected
    setSelectedMenu(); // Update selected menu index

    navigate("/dashboard/about");
  };
const handleDashboard = () => {
  setDashboardSelected(true);
  setWidgetSelected(false);
  setAboutUsSelected(false);  // ✅ FIX
  setSelectedMenu();
  navigate("/dashboard");
};
  //======================================================================
  //======================================================================
  const predefinedOrder = [
    {
      menuOption: 1,
      submenuOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 45]
    },
    {
      menuOption: 2,
      submenuOptions: [20, 21, 22, 47]
    },
    {
      menuOption: 3,
      submenuOptions: [23, 24]
    },
    {
      menuOption: 4,
      submenuOptions: [25, 26, 27]
    },
    {
      menuOption: 5,
      submenuOptions: [28, 29, 30]
    },
    {
      menuOption: 6,
      submenuOptions: [31, 32, 33, 34, 35, 36, 37, 38]
    },
    {
      menuOption: 7,
      submenuOptions: [39, 40, 41]
    },
    {
      menuOption: 8,
      submenuOptions: [42, 43, 44]
    }
  ];

  const reorderMenuOptions = (fetchedMenu) => {
    const menuMap = new Map();

    fetchedMenu.forEach((item) => {
      const menuId = item.mnm_menuid;
      const menuName = item.mnm_menuname;
      const submenuId = item.smnm_submenuid;
      const submenuName = item.SMNM_SubMenuDisplay;

      if (!menuMap.has(menuId)) {
        menuMap.set(menuId, { name: menuName, submenus: [] });
      }

      menuMap.get(menuId).submenus.push({
        submenuId,
        submenuName
      });
    });

    return predefinedOrder
      .map(({ menuOption, submenuOptions }) => {
        if (!menuMap.has(menuOption)) return null;

        const { name, submenus } = menuMap.get(menuOption);

        // Filter & reorder while keeping {submenuId, submenuName}
        const reorderedSubmenus = submenus.filter(({ submenuId }) =>
          submenuOptions.includes(submenuId)
        );

        return {
          menuId: menuOption,           // backend id
          menuName: name,               // display name
          submenuOptions: reorderedSubmenus // array of {id, name}
        };
      })
      .filter(Boolean);
  };


  useEffect(() => {
    const fetchMenuWithOptions = async () => {

      if (!UM_GroupId && parseInt(UM_UserType) !== 0) {
        sessionStorage.clear();
        localStorage.clear();
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });
        window.location.reload();
        navigate("/");

        return;
      }


      try {
        const response = await fetch(`${config.API_URL}/rights`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ UM_GroupId, UM_UserType }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch menu with options");
        }

        const data = await response.json();
        const reordered = reorderMenuOptions(data || []);

        setMenuWithOptions(reordered);

      } catch (error) {
        console.error("Error fetching menu with options:", error);
        setError("Error fetching menu with options");

      }

    };





    const fetchScpOptions = async () => {
      try {
        const response = await fetch(
          `${config.API_URL}/api/scpnames/${UM_UserId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch SCP options");
        }
        const data = await response.json();
        const fetchedScpOptions = data.scpNames || [];
        setScpOptions(fetchedScpOptions);

        // Update selectedScpName based on selectedScpId
        const scpName = getScpNameById(selectedScpId, fetchedScpOptions);
        if (scpName) {
          setSelectedScpName(scpName);
        } else {
          // If no valid name found, fallback to default SCP
          const defaultScpName = getScpNameById(
            UM_DefaultSCPId,
            fetchedScpOptions
          );
          setSelectedScpName(defaultScpName);
        }
      } catch (error) {
        console.error("Error fetching SCP options:", error);
      }
    };

    fetchMenuWithOptions();
    fetchScpOptions();
  }, [UM_GroupId, UM_UserId, UM_DefaultSCPId, selectedScpId]);

  // Store selected SCP data in sessionStorage
  useEffect(() => {
    const selectedScpData = {
      id: selectedScpId,
      name: selectedScpName,
    };
    sessionStorage.setItem("selectedScpData", JSON.stringify(selectedScpData));
  }, [selectedScpId, selectedScpName]);

  const logAudit = async (
    module,
    message,
    oldValue = "",
    newValue = "",
    audittype
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module, // Name of the screen or module
      AUTR_OldValue: oldValue, // Old value if applicable, else empty
      AUTR_NewValue: newValue, // New value if applicable, else empty
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: audittype,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  // Logging function using API
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Dashboard",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const handleMenuClick = (index) => {
    if (activeMenu === index) {
      setActiveMenu(null); // collapse if clicked again
    } else {
      setActiveMenu(index); // expand only this one
    }

    setSelectedMenu(index);
    setDashboardSelected(false);
    setWidgetSelected(false);
    setAboutUsSelected(false);

    logAction(
      `handleMenuClick() : Clicked Menu : ${menuWithOptions[index].menuName}`
    );
  };

  const submenuAuditMap = {
    1: 2,
    2: 4,
    4: 3,
    6: 5,
    12: 6,
    10: 7,
    9: 8,
    23: 11,
    21: 14,
    11: 13,
    8: 10
  };


  const submenuPathMap = {
    1: `/dashboard/companygroupmaster`,
    2: `/dashboard/companymaster`,
    3: '/GCM',
    4: `/dashboard/citpm`,
    6: `/dashboard/GroupM`,
    8: `/dashboard/usermaster`,
    9: `/dashboard/scpmaster`,
    10: `/dashboard/lgcm`,
    11: `/dashboard/rm`,
    12: `/dashboard/LocationMaster`,
    13: '/DMMAIN',
    14: '/LCM',
    15: '/LM',
    16: '/TM',
    17: '/dashboard/sthome',  // last value for 14 used
    21: `/dashboard/scpconfig`,
    22: `/dashboard/EmailConfiguration`,  // last value for 19 used
    20: '/dashboard/companyconfig',

    23: `/dashboard/ordermaster`,
    24: `/dashboard/ordermaster`,

    25: `/dashboard/shipment`,
    26: `/dashboard/ShipmentSelectScanType`,
    27: `/dashboard/shipmentreturn`,

    28: `/dashboard/OrderVerification`,
    29: `/dashboard/shipmentapproval`,

    31: `/dashboard/Auditreport`,
    33: `/dashboard/SupplyChainTransaction`,
    35: `/dashboard/inventory`,
    36: `/dashboard/OrderReport`,
    37: `/dashboard/shipmentreport`,
    38: '/dashboard/RsnHistory',
        45: '/SchemeMaster',
        47: '/dashboard/companyconfig'

  };
    
  const handleSubMenuClick = (option, menuIndex, optionName) => {
     setSelectedMenu(menuIndex);
  setWidgetSelected(false);
  setDashboardSelected(false);
  setAboutUsSelected(false);

    // Get path from map or handle special cases
    let path = submenuPathMap[option];
    if (option === 11) path = `/dashboard/rm`; // special case

    // Use custom audit mapping or fallback to menuIndex
    const auditIndex = submenuAuditMap[option] ?? menuIndex;

    // Determine extra state to pass while navigating
    let state = undefined;

    if (option === 23) {
      state = { BYSCP: 1 };
    } else if (option === 24) {
      state = { BYSCP: 0 };
    }

    // ✅ Clean existing state before reassigning
    if (state) {
      // Remove any previous BYSCP-related state
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    if (path) {
      logAudit(optionName, `Accessed ${optionName}`, "-", "-", auditIndex);
      logAction(`handleSubMenuClick() : Clicked on Submenu : ${optionName}`);

      // ✅ Pass new state cleanly
      if (state) {
        console.log("🌐 Navigating with clean state:", state);
        navigate(path, { state, replace: true }); // replace ensures clean history
      } else {
        console.log("🌐 Navigating without state");
        navigate(path, { replace: true });
      }
    } else {
      console.error("Path not found for submenu:", option, optionName);
      setShowWorkInProgressModal(true); // Show modal when path not found
    }

  };
  const handleCloseModal = () => {
    setShowWorkInProgressModal(false);
  };

  if (error) {
    return <div>{error}</div>;
  }

  const handleChangeScp = (id) => {

    const scpName = getScpNameById(id, scpOptions);
    if (scpName) {
      setSelectedScpId(id);
      setSelectedScpName(scpName);
    }
    window.location.reload();
    logAction(`handleChangeScp() : Changed SCP to : ${selectedScpId}`);

  };

  const toggleOptionsVisibility = () => {
    setIsOptionsVisible(!isOptionsVisible);
  };

  const handleOptionClick = (option) => {

    setSelectedScpName(option.name);
    setSelectedScpId(option.id);
    handleChangeScp(option.id);
    setSelectedOption(true);
    setIsOptionsVisible(false);
  };


  return (
    <>
      
      <div className="Leftpanel">
        <div className="menu-options-container">
          <div className="menu-item" onClick={handleDashboard}>

            {parseInt(UM_UserType) !== 0 && (
              <div
                className={
                  isDashboardSelected ? "selected-menu" : "accordion-header"
                }
              >

                Dashboard
              </div>
            )}
          </div>

          {menuWithOptions.map((menuOption, index) => (
            <div key={menuOption.menuId} className="accordion">
              <div className="menu-item">
                {menuOption.submenuOptions.length === 1 ? (
                  // Treat single submenu as direct menu
                  <div
                    onClick={() =>
                      handleSubMenuClick(
                        menuOption.submenuOptions[0].submenuId,
                        index,
                        menuOption.submenuOptions[0].submenuName
                      )
                    }
                    className={selectedMenu === index ? "selected-menu" : "accordion-header"}
                    style={{
                      height: menuOption.submenuOptions[0].submenuId === 24 ? "55px" : ""
                    }}
                  >
                    {menuOption.submenuOptions[0].submenuName}
                  </div>

                ) : (
                  // Normal accordion for multiple submenus
                  <>
                    <div
                      onClick={() => handleMenuClick(index)}
                      className={selectedMenu === index ? "selected-menu" : "accordion-header"}
                    >
                      {menuOption.menuName}
                      <FontAwesomeIcon
                        className="arrow"
                        icon={activeMenu === index ? faAngleUp : faAngleDown}
                      />
                    </div>

                    {activeMenu === index && (
                      <div className="accordion-body">
                        {menuOption.submenuOptions.map((submenu) => (
                          <div
                            key={submenu.submenuId}
                            onClick={() =>
                              handleSubMenuClick(submenu.submenuId, index, submenu.submenuName)
                            }
                            className="submenu"
                          >
                            <li>{submenu.submenuName}</li>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}


          {/* {parseInt(UM_UserType) !== 0 && (
            <div className="menu-item" onClick={handleWidgets}>
              <div
                className={isWidgetSelected ? "selected-menu" : "accordion-header"}
              >
                Widgets
              </div>
            </div>
          )} */}

          <div className="menu-item" onClick={handleAboutUs}>
            <div
              className={
                isAboutUsSelected ? "selected-menu" : "accordion-header"
              }
            >

              About Us
            </div>
          </div>




          {parseInt(UM_UserType) === 3 && (
            <div className="mb-4">
              <label htmlFor="scpName" className="scp_label">
                SCP Name{" "}
              </label>
              <div className="mb-2"></div>


              <div>
              </div>
              <div className="menu-item">
                <div
                  className="accordion-header"
                  onClick={toggleOptionsVisibility}
                >
                  {selectedScpName}
                  <FontAwesomeIcon
                    className="arrow"
                    icon={isOptionsVisible ? faAngleUp : faAngleDown}
                  />
                </div>
                {isOptionsVisible && (
                  <ul className="submenu">
                    {scpOptions.map((option, index) => (
                      <li
                        key={index}
                        className="submenu"
                        onClick={() => handleOptionClick(option)}
                      >
                        {option.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
        </div>
        <div
          className="modal"
          style={{ display: showWorkInProgressModal ? "block" : "none" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Alas</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">Work in progress.</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;

